export default "__VITE_ASSET__BIJ_E1c0__"